import React, { createContext, useState, useContext } from "react";

const EmailVerContext = createContext();

export default function AmbienteProvider({ children }) {
  const [desafioEmail_id, setDesafioEmail_id] = useState();

  return (
    <EmailVerContext.Provider value={{ desafioEmail_id, setDesafioEmail_id }} >
      {children}
    </EmailVerContext.Provider>
  );
}

export function useEmailVerContext() {
  const context = useContext(EmailVerContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { desafioEmail_id, setDesafioEmail_id } = context;
  return { desafioEmail_id, setDesafioEmail_id };
}

